/* eslint-disable @typescript-eslint/no-explicit-any */

type Obj = Record<PropertyKey, any>;

export function isEmptyObject(obj: Obj): boolean {
    return obj
        && Object.keys(obj).length === 0
        && Object.getPrototypeOf(obj) === Object.prototype;
}

export function objectKeys<K extends PropertyKey>(obj: Record<K, any>): K[] {
    return Object.keys(obj) as K[];
}

export function objectValues<K extends PropertyKey, T>(obj: Record<K, T>): T[] {
    return objectKeys(obj).map(key => obj[key]);
}

export function objectToArray<TKey extends PropertyKey, TVal, TRes>(obj: Record<TKey, TVal>, func: (key: TKey, value: TVal, i: number) => TRes): TRes[] {
    return objectKeys(obj).map((key, i) => func(key, obj[key], i));
}

export function mapObjectValues<TKey extends PropertyKey, TVal, TRes>(obj: Record<TKey, TVal>, selector: (key: TKey, value: TVal) => TRes): Record<TKey, TRes> {
    const result = {} as Record<TKey, TRes>;
    objectKeys(obj).forEach(key => { result[key] = selector(key, obj[key]); });

    return result;
}